import { Button, Stack, Typography } from "@mui/material";
import { useState } from "react";

type Props = {
  label: string;
  list: string[];
};

export const ProductMissingBlock = ({ label, list }: Props) => {
  const [isShowAll, setIsShowAll] = useState<boolean>(false);

  const isRoles = label === "Missing Roles:";

  return (
    <Stack
      flexDirection={"row"}
      gap={"16px"}
      alignItems={list.length === 0 ? "center" : "flex-start"}
    >
      <Typography
        sx={{
          fontSize: "13px",
          lineHeight: "35px",
          fontWeight: 500,
          color: "#1F2932",
          width: "152px",
          flexShrink: 0,
        }}
      >
        {label}
      </Typography>
      <Stack flexDirection={"row"} gap={"8px"} flexWrap={"wrap"}>
        {list.length === 0 && (
          <Typography
            sx={{
              fontSize: "14px",
              lineHeight: "26px",
              fontWeight: 400,
              color: "#464646",
              alignSelf: "center",
            }}
          >
            {isRoles
              ? "No BC roles identified yet"
              : "No job functions identified yet"}
          </Typography>
        )}
        {(isShowAll ? list : list.slice(0, 3)).map((el) => (
          <Typography
            key={el}
            sx={{
              fontSize: "13px",
              lineHeight: "13px",
              fontWeight: 500,
              color: "#1F2932",
              padding: "10px 12px",
              border: isRoles ? "none" : "1px solid #A4B1C4",
              borderRadius: "6px",
              backgroundColor: isRoles ? "#E8ECF0" : "none",
            }}
          >
            {el}
          </Typography>
        ))}
      </Stack>
      {list.length > 3 && (
        <Button
          onClick={() => setIsShowAll((prev) => !prev)}
          variant="text"
          sx={{
            color: "#585858",
            backgroundColor: "#EEEEEE",
            width: "max-content",
            maxWidth: "112px",
            padding: "4px 20px",
            borderRadius: "6px",
            "&:hover": {
              backgroundColor: "#F1F1F1",
            },
            marginLeft: "auto",
            flexShrink: 0,
          }}
        >
          {isShowAll ? "Hide" : `View all (${list.length})`}
        </Button>
      )}
    </Stack>
  );
};
